module.exports = __webpack_public_path__ + "static/media/draw-25.6d888110.png";